export let data = {
  title: "Ubah Komisi",
  backBtn: "/komisi",
  actionBtn: [

  ],
  breadcrumb: [
    { title: "Komisi", link: "/komisi" },
    { title: "Ubah Komisi", active: true }
  ]
};